import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CacheService } from 'projects/common/src/app/services';
import { environment } from 'src/environments/environment';

export interface IGAnalytics {
  apiSecret: string;
  measurementId: string;
  gaEvent: IGaEvent;
}
export interface IGaEvent {
  client_id: string;
  non_personalized_ads: boolean;
  events: {
    name: string;
    params: { [key: string]: any };
  }[];
}

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  private user: any;
  private url = `http://${environment.gaHost}:${environment.gaPort}/api/GoogleAnalytictsControler/GoogleAnalyticsSender`;
  private clientId: string;
  private sessionId: number;

  constructor(private cacheService: CacheService, private http: HttpClient) {
    this.user = this.cacheService.local('session')?.user;
    if (environment.gaId) {
      this.clientId = this.getClientId();
      this.sessionId = this.getSessionId();
    }
  }

  public sendPageView(pageview: string): void {
    this.sendEvent('page_view', {
      page_title: pageview,
      page_path: pageview,
    });
  }

  public sendCustomEvent(eventName: string, eventParameters: { [key: string]: any }): void {
    eventParameters = {
      ...eventParameters,
      loginName: this.user?.loginName ?? '',
    };
    this.sendEvent(eventName, eventParameters);
  }

  public sendExcelDownloadEvent(eventParameters: { [key: string]: string }): void {
    this.sendCustomEvent('excel_download', eventParameters);
  }
  public sendWidgetEvent(eventParameters: { [key: string]: string }): void {
    this.sendCustomEvent('widget', eventParameters);
  }
  public sendFilterEvent(eventParameters: { [key: string]: any }): void {
    if (eventParameters?.filter_selected === 'filter_machine') {
      eventParameters = this.getParameters(eventParameters);
    } else if (eventParameters?.filter_selected === 'filter_machine_type') {
      eventParameters = this.getParameters(eventParameters);
    } else if (eventParameters?.filter_selected === 'filter_shift') {
      eventParameters = this.getParameters(eventParameters);
    } else if (eventParameters?.filer_selected === 'filter_date') {
      const fromDate = eventParameters?.value_selected.from as NgbDate;
      const endDate = eventParameters?.value_selected.to as NgbDate;
      let value = '';
      let month = null;
      let day = null;
      if (endDate) {
        month = endDate.month < 10 ? `0${endDate.month}` : endDate.month;
        day = endDate.day < 10 ? `0${endDate.day}` : endDate.day;
        value = `- ${endDate.year}/${month}/${day}`;
      }
      if (fromDate) {
        month = fromDate.month < 10 ? `0${fromDate.month}` : fromDate.month;
        day = fromDate.day < 10 ? `0${fromDate.day}` : fromDate.day;
        value = `${fromDate.year}/${month}/${day} ${value}`;
      }
      eventParameters.value_selected = value;
    }
    this.sendCustomEvent('filter', eventParameters);
  }
  public getParameters(eventParameters: any) {
    let newEventParameters = {};
    let name = '';
    for (const key in eventParameters) {
      if (Object.prototype.hasOwnProperty.call(eventParameters, key)) {
        const element = eventParameters[key];
        if (key === 'filter_selected') {
          newEventParameters = {
            [key]: eventParameters[key],
          };
        } else if (Array.isArray(element)) {
          // Verificar si element es un array
          for (const i of element) {
            name = `${i.name}, ${name}`;
          }
        }
      }
    }
    newEventParameters = {
      ...newEventParameters,
      value_selected: name.substring(0, name.length - 2),
    };
    return newEventParameters;
  }

  private sendEvent(eventName: string, eventParameters: { [key: string]: any }): void {
    if (environment.gaId && this.clientId && this.sessionId) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };
      const body: IGAnalytics = {
        apiSecret: environment.gaApiSecret,
        measurementId: environment.gaId,
        gaEvent: {
          client_id: this.clientId,
          non_personalized_ads: false,
          events: [
            {
              name: eventName,
              params: {
                items: [],
                loginName: this.user?.loginName ?? '',
                session_id: this.sessionId,
                ...eventParameters,
              },
            },
          ],
        },
      };
      this.http.post(this.url, body, httpOptions).subscribe({
        error: (err) => {},
      });
    }
  }
  private getCookie(name: string) {
    const ca: Array<string> = document.cookie.split(';');
    const caLen: number = ca.length;
    const cookieName = `${name}=`;
    let c: string;
    for (let i = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) === 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
  private getClientId(): string {
    const clientIdCookie = this.getCookie('_ga');
    const clientIdSegmented = clientIdCookie ? clientIdCookie.split('.') : null;
    const clientId = clientIdSegmented ? `${clientIdSegmented[2]}.${clientIdSegmented[3]}` : null;
    return clientId;
  }
  private getSessionId(): number {
    const { gaId } = environment;
    const subId = gaId?.substring(2, gaId.length);
    const sessionIdCookie = this.getCookie(`_ga_${subId}`);
    const seessionIdSegmented = sessionIdCookie ? sessionIdCookie.split('.') : null;
    const sessionId = seessionIdSegmented ? +seessionIdSegmented[2] : null;
    return sessionId;
  }
}
